import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { DevToolsButtonComponent } from './dev-tools-button.component';
import { DevToolsPanelComponent } from './dev-tools-panel.component';

@NgModule({
  declarations: [DevToolsButtonComponent, DevToolsPanelComponent],
  imports: [
    CommonModule,
    FormsModule,
    OverlayModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatInputModule,
  ],
  exports: [DevToolsButtonComponent],
})
export class DevToolsModule {}
